import React from 'react'

export default function Today() {
  return (
    <div>
      <h6>TODAY<i className="icon icon-star text-purple mx-2"></i></h6>
    </div>
  )
}
